module.exports = __webpack_public_path__ + "img/jyxq.ad19d788.jpg";